import cn from 'classnames'
import { memo, PropsWithChildren, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { IFieldWrapperWithChangesProps } from './models'
import { fieldWrapperWithChangesTranslations } from './translations'

import styles from './FieldWrapperWithChanges.module.scss'

export const FieldWrapperWithChanges = memo<PropsWithChildren<IFieldWrapperWithChangesProps>>(
  ({ children, hasChanges, isHidden }) => {
    const renderTipContent = useCallback(
      () => <Translation text={fieldWrapperWithChangesTranslations.tipContent} span />,
      []
    )

    if (isHidden || !hasChanges) {
      return <div className={styles.container}>{children}</div>
    }

    return (
      <div className={cn(styles.container, styles.highlight)}>
        {children}
        <span className={styles.icon}>
          <Tooltip tipContent={renderTipContent}>
            <i className="kbase kbase-omni-text" />
          </Tooltip>
        </span>
      </div>
    )
  }
)
